import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const ESTADOS = ["pendiente", "confirmado", "cancelado", "completado"];

export default function CrmEventos() {
    const [eventos, setEventos] = useState([]);
    const [filtro, setFiltro] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const params = filtro ? { estado: filtro } : {};
        api.get("/eventos", { params })
            .then((r) => setEventos(r.data))
            .catch((err) => toast.error(formatApiError(err)))
            .finally(() => setLoading(false));
    }, [filtro]);

    return (
        <div className="space-y-10">
            <header className="flex items-end justify-between flex-wrap gap-6">
                <div>
                    <p className="font-body uppercase tracking-[0.3em] text-xs text-dorado mb-3">
                        Eventos privados
                    </p>
                    <h1 className="font-heading text-5xl text-crema font-light">
                        Bodas, comuniones, empresa
                    </h1>
                </div>
                <div>
                    <label className="line-label">Estado</label>
                    <select
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        className="input-line bg-carbon min-w-[140px]"
                        data-testid="filter-evento-estado"
                    >
                        <option value="">Todos</option>
                        {ESTADOS.map((e) => (
                            <option key={e} value={e}>
                                {e}
                            </option>
                        ))}
                    </select>
                </div>
            </header>

            {loading ? (
                <p className="text-piedra italic font-body">Cargando...</p>
            ) : eventos.length === 0 ? (
                <p className="text-piedra italic font-body">No hay eventos.</p>
            ) : (
                <div className="border border-dorado/20 bg-carbon-suave/40 divide-y divide-dorado/10">
                    {eventos.map((e) => (
                        <Link
                            key={e.id}
                            to={`/crm/eventos/${e.id}`}
                            className="px-5 py-4 grid grid-cols-1 md:grid-cols-6 gap-3 items-center hover:bg-carbon"
                            data-testid="crm-evento-row"
                        >
                            <span className="font-heading text-xl text-dorado">{e.tipo}</span>
                            <span className="font-body text-sm text-crema">{e.nombre}</span>
                            <span className="font-body text-sm text-piedra">{e.fecha || "—"}</span>
                            <span className="font-body text-sm text-piedra">
                                {e.personas || "—"} pax
                            </span>
                            <span className="font-body text-xs text-piedra">
                                {e.email || e.telefono || "—"}
                            </span>
                            <span
                                className={`font-body text-[0.65rem] uppercase tracking-[0.2em] px-3 py-1 border w-fit ${
                                    e.estado === "confirmado"
                                        ? "border-dorado text-dorado"
                                        : e.estado === "cancelado"
                                        ? "border-red-400/50 text-red-400"
                                        : e.estado === "completado"
                                        ? "border-piedra text-piedra"
                                        : "border-piedra/40 text-piedra"
                                }`}
                            >
                                {e.estado}
                            </span>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
